// Shared display helpers for AI draft items (decks + cards).
// Shapes may vary while the backend is being built — render defensively.

export const getAiItemId = (item) => item?._id ?? item?.id;

/**
 * El `meaning` de una card llega del $lookup del API. Normalmente viene ya
 * desenrollado a objeto, pero según el endpoint puede llegar como array de un
 * elemento (o vacío, si la card aún no tiene su example de type=Meaning).
 */
const getMeaning = (item) => {
  const meaning = item?.meaning;
  return Array.isArray(meaning) ? meaning[0] : meaning;
};

/**
 * Traducción de una card. El API devuelve `translations: [{ lang, trans, active }]`
 * — no un campo `trans` plano —, así que hay que buscar el idioma dentro del array.
 * Se prefiere inglés y se cae a cualquier otro idioma antes que no mostrar nada.
 */
export const getAiItemTranslation = (item, lang = "en") => {
  const meaning = getMeaning(item);
  const list = meaning?.translations || item?.translations;
  if (Array.isArray(list) && list.length) {
    const wanted = list.find((t) => t?.lang === lang && t?.active !== false && t?.trans);
    if (wanted) return wanted.trans;
    const any = list.find((t) => t?.active !== false && t?.trans);
    if (any) return any.trans;
  }
  return meaning?.trans || item?.translation || item?.trans || undefined;
};

export const getAiItemTitle = (item) => {
  const id = getAiItemId(item);
  return (
    item?.title ||
    item?.name ||
    getMeaning(item)?.character ||
    item?.character ||
    item?.word ||
    (id !== undefined && id !== null ? `#${id}` : "—")
  );
};

export const getAiItemSubtitle = (item, type) => {
  // "collision" es la pestaña de glosa repetida: son cards, así que el
  // subtítulo se construye igual (pinyin · traducción).
  if (type === "card" || type === "collision") {
    const meaning = getMeaning(item);
    const pinyin = meaning?.pinyin || item?.pinyin;
    return [pinyin, getAiItemTranslation(item)].filter(Boolean).join(" · ");
  }
  const level = item?.level;
  const category =
    typeof item?.category === "string" ? item?.category : item?.category?.name || item?.category?.title;
  return [level, category].filter(Boolean).join(" · ");
};

export const isAiItemPremium = (item) => !!item?.premium?.active;
